import AssigneesToolbar from '../../assignees/AssigneesToolbar';
import {ButtonConfig} from '../../../../../../controllers/dialog/ButtonConfig';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import {ButtonSize, MessageStatus} from '@sabre/spark-react-core/types';
import {cssClasses} from '../../../../../../common/helpers/browser/cssClasses';
import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import {DefaultTableCheckboxModeProps} from '../../../../common/components/table/DefaultTable';
import AddToGroupModal from './AddToGroupModal';
import {ModalButtons} from '../../../../../../controllers/dialog/ModalButtons';
import {asNumber} from '../../../../../../common/helpers/converters/asNumber';
import styles from './AddAgentsToolbar.module.css';

export default function AddAgentsToolbar(props: DefaultTableCheckboxModeProps) {
    const controllers = useControllers();
    const http = controllers.http;
    const dialog = controllers.dialog;
    const groups = controllers.groups;
    const agents = controllers.agents;

    const toolbarButtons: ButtonConfig[] = [
        {
            className: cssClasses('aat-autokey-escape', 'qa-delete-toolbar-cancel-button'),
            secondary: true,
            children: tAsString('CANCEL'),
            size: ButtonSize.SMALL,
            onClick: () => http.navigateTo('agents')
        },
        {
            className: cssClasses('qa-add-assignee-button'),
            children: tAsString('ADD_TO_GROUP'),
            size: ButtonSize.SMALL,
            onClick: () => {
                if (props.checkedRows.length > 0) {
                    dialog.showModal({
                        title: tAsString('ADD_TO_GROUP'),
                        children: <AddToGroupModal
                            checkedRows={props.checkedRows}
                            setCheckedRows={props.setCheckedRows}/>,
                        buttons: [
                            ModalButtons.CANCEL(dialog),
                            {
                                children: tAsString('ADD'),
                                ariaLabel: tAsString('ADD_ASSIGNEES'),
                                className: 'qa-add-button',
                                onClick: async () => {
                                    const currentModal = await dialog.getCurrentModal$();

                                    if (currentModal?.data?.groupId === 'NEW_GROUP') {
                                        agents.setToAddAssignees(props.checkedRows);
                                        await dialog.closeModal();
                                        await http.navigateTo('groups/create/details.new');
                                    } else {
                                        const groupId = asNumber(currentModal?.data?.groupId);
                                        const group = await groups.getGroupById$(groupId);

                                        await dialog.takeNotifiedAction({
                                            action: async () => {
                                                await agents.assignAgentsToGroup$(groupId, props.checkedRows);
                                            },
                                            successMessage: tAsString('THE_X_GROUP_HAS_BEEN_UPDATED', {name: group?.name}),
                                            errorMessage: tAsString('THE_X_GROUP_UPDATE_FAILED', {name: group?.name})
                                        });
                                        await dialog.closeModal();
                                    }
                                }
                            }
                        ],
                        contentClassName: cssClasses(styles.Modal, 'col-xs-12', 'col-sm-10', 'col-md-7', 'col-lg-6', 'col-xl-5', 'qa-add-to-group-modal')
                    }).andWeAreDone();
                } else {
                    dialog.showNotification({
                        status: MessageStatus.WARNING,
                        content: tAsString('SELECT_SOME_OPTIONS')
                    }).andWeAreDone();
                }
            }
        }
    ];

    return <AssigneesToolbar
        buttonsConfig={toolbarButtons}
        checkedRows={props.checkedRows}
        setCheckedRows={props.setCheckedRows}
    />;
}